var Context = /** @class */ (function () {
    function Context() {
    }
    Context.getGlobalContext = function () {
        return window;
    };
    Context.getGlobalContextStorage = function () {
        return Context.getGlobalContext()['data'];
    };
    return Context;
}());
export { Context };
Context.getGlobalContext()['data'] = {};
//# sourceMappingURL=Context.js.map